import React from "react";
import { Navigate } from "react-router";
import { Container } from "@mui/material";
import TimeOutSession from "../utils/TimeOutSession";
import DashboardTemp from "../pages/portal/dashboard/DashboardTemp";

const ProtectedRoutes = ({ user, token, children, redirecTo = "/" }) => {

  // && token !== sessionStorage.getItem("sessionToken")

  if (!user && token !== sessionStorage.getItem("sessionToken")) {
    return <Navigate to={redirecTo} />;
  }


  return (
    <Container
      maxWidth="lx"
      style={{
        display: "flex",
        flexDirection: "column",
        margin: 0,
        padding: 0,
        position: "relative",
      }}
    >
      <Container
        maxWidth="lx"
        style={{
          display: "flex",
          flexDirection: "row",
          margin: 0,
          padding: 0,
        }}
      >
        <Container
          maxWidth="lx"
          style={{
            margin: 0,
            padding: 0,
          }}
        >
          <TimeOutSession />

          <DashboardTemp children={children} />
        </Container>
      </Container>
    </Container>
  );
};

export default ProtectedRoutes;
